interface IHeaderDropdownData {
  src: string;
  text: string;
  qaMarker: string;
  bell?: boolean;
}

export const HeaderDropdownData: IHeaderDropdownData[] = [
  {
    src: '/profile',
    text: 'Мои вопросы',
    qaMarker: 'my_questions_btn',
    bell: true,
  },
  {
    src: '/profile/answers',
    qaMarker: 'my_answers_btn',
    text: 'Мои ответы',
  },
];

export type BannerType = {
  mobile: BackgroundImages;
  tablet: BackgroundImages;
  desktop: BackgroundImages;
  link: string;
};

export type HeaderInfo = {
  unanswered_count: number;
  banner: BannerType;
};

export type BackgroundImages = {
  background: string;
  url: string;
  end_time: string;
};
